import {
  Component,
  Output,
  EventEmitter,
  SimpleChanges,
  OnInit,
  OnChanges,
  OnDestroy,
  HostListener,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { ViewEncapsulation, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, FormArray, AbstractControl, FormControl } from '@angular/forms';

import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { tap, map, startWith } from 'rxjs/operators';
import { retry, catchError } from 'rxjs/operators';
import { switchMap } from 'rxjs/operators';

import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
// import { STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
// import { DeviceDetectorService } from 'ngx-device-detector';

// import { DatePipe } from '@angular/common';

// import * as tus from 'tus-js-client';
// import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from '@ngx-gallery/core';

import { environment } from '../../environments/environment';

import { AuthQuery } from '@app/auth/auth.query';

// import { JournalService, Journal, JournalSingle, JournalTable, MailService, Mail } from '@core';
// import { CookieService } from 'ngx-cookie-service';

import { AuthDataService } from '@app/auth/auth-data.service';
// import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS_FACTORY } from '@angular/material/progress-spinner';

// import { requireAtLeastOneCheckboxValidator } from '../@shared/validation/require-checkboxes-to-be-checked.validator';

import { ConfirmDialogComponent } from '../@shared/dialog/confirm-dialog/confirm-dialog.component';
// import { TranslateLandPipe } from '@app/@shared/pipe/translate-land.pipe';

import {
  ZahlungsabgleichService,
  Zahlung,
  ZahlungSingle,
  JournalEntry,
  PaymentStatus,
  ReconciliationStatus,
  ImportBatch
} from '../services/zahlung.service';

import { MandatService, Mandat } from '../services/mandat.service';

declare var $: any;

@Component({
  selector: 'app-zahlung-edit',
  templateUrl: './zahlung_edit.component.html',
  styleUrls: ['./zahlung_edit.component.scss'],
  providers: [],
})
export class ZahlungEditComponent implements OnInit, OnChanges, OnDestroy {
  @Input() zahlungId: number | null = null;
  @Output() zahlungSaved = new EventEmitter<Zahlung>();
  @Output() zahlungCancelled = new EventEmitter<void>();

  private routeSub?: Subscription;

  // @ViewChild('fileInput') fileInput: ElementRef;

  // Form
  frmZahlung: FormGroup;
  isFormValid = false;
  isFormDirty = false;
  isFormSubmitted = false;

  // Data
  zahlung: Zahlung | null = null;
  relatedMandates: Mandat[] = [];
  paymentHistory: Zahlung[] = [];
  lifecycle: JournalEntry[] = [];  // full mandate journal (accounting statement)
  stammdaten: any = null;
  isLoading = false;
  isSaving = false;
  isExportingRetour = false;

  // Mandate search (Mandat Zuordnung tab)
  mandatSearchTerm = '';
  mandatSearchResults: Mandat[] = [];
  onlyOpenMandate = true;
  isSearchingMandate = false;

  // Mandate preview modal
  showMandatePreview = false;
  previewMandat: Mandat | null = null;
  previewJournal: JournalEntry[] = [];
  isLoadingPreviewJournal = false;

  // File upload
  uploadedFiles: any[] = [];
  maxFileSize = 10 * 1024 * 1024; // 10MB
  allowedFileTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];

  // Gallery
  galleryItems: any[] = [];
  galleryId = 'zahlung-gallery';

  // Device detection
  isMobile = false;

  // Payment status options
  paymentStatusOptions = [
    { value: PaymentStatus.UNBEKANNT, label: 'Unbekannt' },
    { value: PaymentStatus.ZUGEORDNET, label: 'Zugeordnet' },
    { value: PaymentStatus.VOLLSTAENDIG, label: 'Vollständig' },
    { value: PaymentStatus.TEILWEISE, label: 'Teilweise' },
    { value: PaymentStatus.ÜBERZAHLT, label: 'Überzahlt' },
    { value: PaymentStatus.UNTERZAHLT, label: 'Unterzahlt' },
    { value: PaymentStatus.DOPPELT, label: 'Doppelt' },
    { value: PaymentStatus.STORNIERT, label: 'Storniert' },
    { value: PaymentStatus.ZURÜCKGEBUCHT, label: 'Zurückgebucht' }
  ];

  // Reconciliation status options
  reconciliationStatusOptions = [
    { value: ReconciliationStatus.OFFEN, label: 'Offen' },
    { value: ReconciliationStatus.GEPRÜFT, label: 'Geprüft' },
    { value: ReconciliationStatus.ABGESCHLOSSEN, label: 'Abgeschlossen' },
    { value: ReconciliationStatus.PROBLEM, label: 'Problem' },
    { value: ReconciliationStatus.ZURÜCKGEBUCHT, label: 'Zurückgebucht' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private zahlungsabgleichService: ZahlungsabgleichService,
    private mandatService: MandatService,
    private authQuery: AuthQuery,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private authDataService: AuthDataService
  ) {
    this.isMobile = false; // Simple mobile detection
    this.initializeForm();
  }

  ngOnInit(): void {
    this.loadStammdaten();
    this.setupFormValidation();

    // The component is rendered via a child route inside the offcanvas
    // router-outlet, so @Input() is never bound. Read the id from the route.
    this.routeSub = this.route.queryParams.subscribe((params) => {
      const id = params['id'] ? +params['id'] : null;
      this.zahlungId = id && !isNaN(id) ? id : null;
      this.loadZahlung();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['zahlungId'] && !changes['zahlungId'].firstChange) {
      this.loadZahlung();
    }
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
  }

  private initializeForm(): void {
    this.frmZahlung = this.fb.group({
      // Bank Data (read-only)
      bank_transfer_id: [''],
      bank_tx_id: [''],
      bank_msg_id: [''],
      bank_stmt_id: [''],
      betrag: ['', [Validators.required, Validators.min(0.01)]],
      currency: ['EUR'],
      credit_debit_indicator: ['CRDT'],
      valuta_datum: ['', Validators.required],
      buchungs_datum: [''],
      import_datum: [''],
      
      // Bank Transaction Details
      bank_tx_code: [''],
      bank_tx_code_proprietary: [''],
      bank_tx_code_issuer: [''],
      
      // Parties Information
      debtor_name: ['', Validators.required],
      debtor_iban: [''],
      debtor_bic: [''],
      creditor_name: [''],
      creditor_iban: [''],
      creditor_bic: [''],
      
      // Reference Information
      creditor_reference: [''],
      creditor_reference_type: [''],
      purpose_code: [''],
      
      // Mandate Connection
      mandat_id: [''],
      aktenzeichen: [''],
      mandat_betrag_faellig: [''],
      mandat_faelligkeitsdatum: [''],
      
      // Payment Status & Reconciliation
      payment_status: [PaymentStatus.UNBEKANNT, Validators.required],
      reconciliation_status: [ReconciliationStatus.OFFEN, Validators.required],
      betrag_differenz: [''],
      
      // System Fields
      import_batch_id: [''],
      bemerkungen: [''],
      processing_notes: [''],
      is_duplicate: [false],
      is_reversed: [false]
    });

    // Make bank data fields read-only
    const readOnlyFields = [
      'bank_transfer_id', 'bank_tx_id', 'bank_msg_id', 'bank_stmt_id',
      'bank_tx_code', 'bank_tx_code_proprietary', 'bank_tx_code_issuer',
      'debtor_iban', 'debtor_bic', 'creditor_name', 'creditor_iban', 'creditor_bic',
      'creditor_reference', 'creditor_reference_type', 'purpose_code',
      'import_datum', 'import_batch_id'
    ];

    readOnlyFields.forEach(field => {
      this.frmZahlung.get(field)?.disable();
    });
  }

  private setupFormValidation(): void {
    this.frmZahlung.valueChanges.subscribe(() => {
      this.isFormDirty = this.frmZahlung.dirty;
      this.isFormValid = this.frmZahlung.valid;
    });
  }

  private loadStammdaten(): void {
    // Load master data for dropdowns
    // For demo purposes, we'll create mock stammdaten
    this.stammdaten = {
      dienste: [
        { id: 1, name: 'Parkraumüberwachung' },
        { id: 2, name: 'Ordnungsamt' }
      ],
      personen: [
        { id: 1, name: 'admin' },
        { id: 2, name: 'user' }
      ]
    };
  }

  private loadZahlung(): void {
    if (!this.zahlungId) {
      this.createNewZahlung();
      return;
    }

    this.isLoading = true;
    this.zahlungsabgleichService.getZahlungById(this.zahlungId).subscribe({
      next: (response: ZahlungSingle) => {
        this.zahlung = response.data;
        this.relatedMandates = response.related_mandates || [];
        this.mandatSearchResults = [...this.relatedMandates];
        this.paymentHistory = response.payment_history || [];
        this.lifecycle = response.lifecycle || [];
        this.populateForm();
        this.loadGalleryItems();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Error loading zahlung:', error);
        this.snackBar.open('Fehler beim Laden der Zahlung', 'Schließen', { duration: 3000 });
        this.isLoading = false;
      }
    });
  }

  private createNewZahlung(): void {
    this.zahlung = {
      id: 0,
      bank_transfer_id: '',
      bank_tx_id: '',
      bank_msg_id: '',
      bank_stmt_id: '',
      betrag: 0,
      currency: 'EUR',
      credit_debit_indicator: 'CRDT',
      valuta_datum: '',
      buchungs_datum: '',
      import_datum: '',
      bank_tx_code: '',
      bank_tx_code_proprietary: '',
      bank_tx_code_issuer: '',
      debtor_name: '',
      debtor_iban: '',
      debtor_bic: '',
      creditor_name: '',
      creditor_iban: '',
      creditor_bic: '',
      creditor_reference: '',
      creditor_reference_type: '',
      purpose_code: '',
      mandat_id: 0,
      aktenzeichen: '',
      mandat_betrag_faellig: 0,
      mandat_faelligkeitsdatum: '',
      payment_status: PaymentStatus.UNBEKANNT,
      reconciliation_status: ReconciliationStatus.OFFEN,
      betrag_differenz: 0,
      import_batch_id: 0,
      createdate: '',
      createtime: '',
      person: '',
      dienstnr_id: 0,
      dienstnr_stvo: 0,
      bemerkungen: '',
      processing_notes: '',
      is_duplicate: false,
      is_reversed: false
    };
    this.populateForm();
  }

  private populateForm(): void {
    if (!this.zahlung) return;

    this.frmZahlung.patchValue({
      bank_transfer_id: this.zahlung.bank_transfer_id,
      bank_tx_id: this.zahlung.bank_tx_id,
      bank_msg_id: this.zahlung.bank_msg_id,
      bank_stmt_id: this.zahlung.bank_stmt_id,
      betrag: this.zahlung.betrag,
      currency: this.zahlung.currency,
      credit_debit_indicator: this.zahlung.credit_debit_indicator,
      valuta_datum: this.zahlung.valuta_datum,
      buchungs_datum: this.zahlung.buchungs_datum,
      import_datum: this.zahlung.import_datum,
      bank_tx_code: this.zahlung.bank_tx_code,
      bank_tx_code_proprietary: this.zahlung.bank_tx_code_proprietary,
      bank_tx_code_issuer: this.zahlung.bank_tx_code_issuer,
      debtor_name: this.zahlung.debtor_name,
      debtor_iban: this.zahlung.debtor_iban,
      debtor_bic: this.zahlung.debtor_bic,
      creditor_name: this.zahlung.creditor_name,
      creditor_iban: this.zahlung.creditor_iban,
      creditor_bic: this.zahlung.creditor_bic,
      creditor_reference: this.zahlung.creditor_reference,
      creditor_reference_type: this.zahlung.creditor_reference_type,
      purpose_code: this.zahlung.purpose_code,
      mandat_id: this.zahlung.mandat_id,
      aktenzeichen: this.zahlung.aktenzeichen,
      mandat_betrag_faellig: this.zahlung.mandat_betrag_faellig,
      mandat_faelligkeitsdatum: this.zahlung.mandat_faelligkeitsdatum,
      payment_status: this.zahlung.payment_status,
      reconciliation_status: this.zahlung.reconciliation_status,
      betrag_differenz: this.zahlung.betrag_differenz,
      import_batch_id: this.zahlung.import_batch_id,
      bemerkungen: this.zahlung.bemerkungen,
      processing_notes: this.zahlung.processing_notes,
      is_duplicate: this.zahlung.is_duplicate,
      is_reversed: this.zahlung.is_reversed
    });
  }

  private loadGalleryItems(): void {
    // Load images for gallery if any
    this.galleryItems = [];
    // Implementation would load actual images from the server
  }

  /**
   * Search mandates by Aktenzeichen / Kennzeichen. The "nur offene/aktive"
   * checkbox limits the result to active statuses (Status=Aktive => E + U);
   * unchecked searches all statuses so already paid/angezeigt mandates show too.
   */
  searchMandate(): void {
    const filters = this.onlyOpenMandate ? '[["Status","Aktive"]]' : '[["Status","Alle"]]';
    this.isSearchingMandate = true;
    this.mandatService
      .getMandate(1, 25, 'Md_StatusDate', 'desc', this.mandatSearchTerm || '', filters)
      .subscribe({
        next: (response) => {
          this.mandatSearchResults = response.data || [];
          this.isSearchingMandate = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.snackBar.open('Fehler bei der Mandatssuche', 'Schließen', { duration: 3000 });
          this.isSearchingMandate = false;
        },
      });
  }

  /** Assign the picked mandate to the payment form (programmatic). */
  selectMandate(m: Mandat): void {
    this.frmZahlung.patchValue({
      mandat_id: m.Md_PrimKey,
      aktenzeichen: m.Md_BelegNr,
      mandat_betrag_faellig: m.Md_Betrag,
      mandat_faelligkeitsdatum: m.Md_ZahlungsDatum,
    });
    this.frmZahlung.markAsDirty();
    this.calculateDifference();
  }

  isMandatSelected(m: Mandat): boolean {
    return !!m && +this.frmZahlung.get('mandat_id')?.value === +m.Md_PrimKey;
  }

  /** The currently assigned mandate (from the search results / suggestions), if any. */
  get selectedMandat(): Mandat | undefined {
    const id = +this.frmZahlung.get('mandat_id')?.value;
    if (!id) return undefined;
    return (
      this.mandatSearchResults.find((m) => +m.Md_PrimKey === id) ||
      this.relatedMandates.find((m) => +m.Md_PrimKey === id)
    );
  }

  /** Open the Tailwind preview modal and load the mandate journal. */
  openMandatePreview(m: Mandat): void {
    this.previewMandat = m;
    this.previewJournal = [];
    this.showMandatePreview = true;
    if (m?.Md_BelegNr) {
      this.isLoadingPreviewJournal = true;
      this.mandatService.getMandatJournal(m.Md_BelegNr).subscribe({
        next: (response) => {
          this.previewJournal = response.data || [];
          this.isLoadingPreviewJournal = false;
          this.cdr.detectChanges();
        },
        error: () => {
          this.isLoadingPreviewJournal = false;
        },
      });
    }
  }

  closeMandatePreview(): void {
    this.showMandatePreview = false;
    this.previewMandat = null;
    this.previewJournal = [];
  }

  selectFromPreview(): void {
    if (this.previewMandat) {
      this.selectMandate(this.previewMandat);
    }
    this.closeMandatePreview();
  }

  /** Map a mandate status code to a German label. */
  getMandatStatusLabel(status: string | undefined): string {
    switch (status) {
      case 'E': return 'Erfasst';
      case 'T': return 'Teil-Erfasst';
      case 'B': return 'Bezahlt';
      case 'U': return 'Überfällig';
      case 'A': return 'Angezeigt';
      case 'AB': return 'Anzeige/Bezahlt';
      case 'S': return 'Storniert';
      case '8': return 'Ausgenommen';
      case '9': return 'Fehler';
      default: return status || '-';
    }
  }

  /** Tailwind badge classes for a mandate status code. */
  getMandatStatusClass(status: string | undefined): string {
    switch (status) {
      case 'E':
      case 'T':
        return 'bg-blue-100 text-blue-800';
      case 'U':
        return 'bg-amber-100 text-amber-800';
      case 'B':
      case 'AB':
        return 'bg-green-100 text-green-800';
      case 'A':
        return 'bg-red-100 text-red-800';
      case 'S':
      case '8':
        return 'bg-gray-200 text-gray-700';
      default:
        return 'bg-gray-100 text-gray-600';
    }
  }

  /** True if the mandate is in a state that needs caution before assigning. */
  isMandatWarning(status: string | undefined): boolean {
    return ['B', 'AB', 'A', 'S', '8'].includes(status || '');
  }

  /** German warning text for a problematic mandate status. */
  getMandatWarningText(status: string | undefined): string {
    switch (status) {
      case 'B':
      case 'AB':
        return 'Achtung: Mandat ist bereits bezahlt - bitte Doppelzahlung/Retour prüfen.';
      case 'A':
        return 'Achtung: Mandat wurde bereits angezeigt (VSTV) - bitte prüfen.';
      case 'S':
        return 'Achtung: Mandat ist storniert.';
      case '8':
        return 'Achtung: Mandat ist ausgenommen.';
      default:
        return '';
    }
  }

  private calculateDifference(): void {
    const betrag = this.frmZahlung.get('betrag')?.value || 0;
    const mandatBetrag = this.frmZahlung.get('mandat_betrag_faellig')?.value || 0;
    const differenz = betrag - mandatBetrag;
    
    this.frmZahlung.patchValue({
      betrag_differenz: differenz
    });

    // Auto-set payment status based on difference
    if (differenz === 0) {
      this.frmZahlung.patchValue({ payment_status: PaymentStatus.VOLLSTAENDIG });
    } else if (differenz > 0) {
      this.frmZahlung.patchValue({ payment_status: PaymentStatus.ÜBERZAHLT });
    } else if (differenz < 0) {
      this.frmZahlung.patchValue({ payment_status: PaymentStatus.UNTERZAHLT });
    }
  }

  onBetragChange(): void {
    this.calculateDifference();
  }

  saveZahlung(close = false): void {
    if (!this.frmZahlung.valid) {
      this.isFormSubmitted = true;
      this.snackBar.open('Bitte füllen Sie alle erforderlichen Felder aus', 'Schließen', { duration: 3000 });
      return;
    }

    this.isSaving = true;
    const formValue = this.frmZahlung.value;
    
    const updatedZahlung: Zahlung = {
      ...this.zahlung!,
      ...formValue,
      id: this.zahlung?.id || 0
    };

    this.zahlungsabgleichService.updateZahlung(updatedZahlung).subscribe({
      next: (response) => {
        this.snackBar.open('Zahlung wurde gespeichert', 'Schließen', { duration: 3000 });
        this.zahlungSaved.emit(response);
        this.isSaving = false;
        this.isFormDirty = false;
        if (close) {
          this.closeDialog();
        }
      },
      error: (error) => {
        console.error('Error saving zahlung:', error);
        this.snackBar.open('Fehler beim Speichern der Zahlung', 'Schließen', { duration: 3000 });
        this.isSaving = false;
      }
    });
  }

  cancelEdit(): void {
    if (this.isFormDirty) {
      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: {
          title: 'Änderungen verwerfen',
          message: 'Möchten Sie die Änderungen wirklich verwerfen?',
          confirmText: 'Verwerfen',
          cancelText: 'Abbrechen'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.closeDialog();
        }
      });
    } else {
      this.closeDialog();
    }
  }

  /**
   * Close the detail offcanvas. The component is shown via a child route inside
   * the offcanvas router-outlet, so we hide the Bootstrap offcanvas directly and
   * navigate back to the list to clear the child route.
   */
  private closeDialog(): void {
    const el = document.getElementById('staticBackdrop');
    if (el && (window as any).bootstrap?.Offcanvas) {
      const oc = (window as any).bootstrap.Offcanvas.getOrCreateInstance(el);
      oc?.hide();
    }
    this.zahlungCancelled.emit();
    this.router.navigate(['/zahlungsabgleich']);
  }

  assignToMandate(): void {
    const mandatId = this.frmZahlung.get('mandat_id')?.value;
    if (!mandatId) {
      this.snackBar.open('Bitte wählen Sie ein Mandat aus', 'Schließen', { duration: 3000 });
      return;
    }

    this.zahlungsabgleichService.assignToMandate(this.zahlung!.id, mandatId).subscribe({
      next: (response) => {
        this.snackBar.open('Zahlung wurde dem Mandat zugeordnet', 'Schließen', { duration: 3000 });
        this.zahlung = response;
        this.populateForm();
      },
      error: (error) => {
        console.error('Error assigning zahlung:', error);
        this.snackBar.open('Fehler beim Zuordnen der Zahlung', 'Schließen', { duration: 3000 });
      }
    });
  }

  reconcilePayment(): void {
    this.zahlungsabgleichService.reconcilePayment(this.zahlung!.id).subscribe({
      next: (result) => {
        this.snackBar.open(result.message, 'Schließen', { duration: 3000 });
        this.zahlung!.payment_status = result.new_status;
        this.zahlung!.betrag_differenz = result.differenz;
        this.populateForm();
      },
      error: (error) => {
        console.error('Error reconciling payment:', error);
        this.snackBar.open('Fehler beim Abgleichen der Zahlung', 'Schließen', { duration: 3000 });
      }
    });
  }

  /**
   * Export a SINGLE camt.054 retour file for this payment (no Sammeldatei).
   * The backend marks the payment for return (idempotent) and streams the file;
   * we download it as <aktenzeichen>_<kontoname>.xml.
   */
  exportRetour(): void {
    if (!this.zahlung?.id) {
      return;
    }
    const reason = (this.frmZahlung.get('processing_notes')?.value || '').trim();
    if (!reason) {
      this.snackBar.open('Bitte einen Rücküberweisungsgrund angeben', 'Schließen', { duration: 3000 });
      return;
    }

    this.isExportingRetour = true;
    this.zahlungsabgleichService.exportSingleReturn(this.zahlung.id, reason).subscribe({
      next: (blob: Blob) => {
        const filename = this.buildRetourFilename();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.click();
        window.URL.revokeObjectURL(url);
        this.snackBar.open('Rücküberweisung als camt.054 exportiert', 'Schließen', { duration: 4000 });
        this.isExportingRetour = false;
        // reload so the status reflects "Zurückgebucht"
        this.loadZahlung();
      },
      error: () => {
        this.snackBar.open('Fehler beim camt.054-Export', 'Schließen', { duration: 3000 });
        this.isExportingRetour = false;
      }
    });
  }

  /** Build a safe <aktenzeichen>_<kontoname>.xml filename from the form values. */
  private buildRetourFilename(): string {
    const aktenzeichen = (this.frmZahlung.get('aktenzeichen')?.value || '').toString();
    const kontoname = (this.frmZahlung.get('debtor_name')?.value || '').toString();
    const sanitize = (s: string) => s.replace(/[^A-Za-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
    const base = [sanitize(aktenzeichen), sanitize(kontoname)].filter(Boolean).join('_');
    return (base || `retour-zahlung-${this.zahlung?.id || 0}`) + '.xml';
  }

  onFileUpload(event: any): void {
    const files = event.target.files;
    if (files && files.length > 0) {
      for (let file of files) {
        if (this.validateFile(file)) {
          this.uploadFile(file);
        }
      }
    }
  }

  private validateFile(file: File): boolean {
    if (file.size > this.maxFileSize) {
      this.snackBar.open(`Datei ${file.name} ist zu groß (max. 10MB)`, 'Schließen', { duration: 3000 });
      return false;
    }

    if (!this.allowedFileTypes.includes(file.type)) {
      this.snackBar.open(`Dateityp ${file.type} ist nicht erlaubt`, 'Schließen', { duration: 3000 });
      return false;
    }

    return true;
  }

  private uploadFile(file: File): void {
    // Implementation for file upload
    // This would typically use the existing file upload service
  }

  formatCurrency(amount: number): string {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('de-DE');
  }

  formatDateTime(dateString: string | undefined): string {
    if (!dateString) return '';
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return dateString;
    return d.toLocaleString('de-DE', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  }

  getPaymentStatusLabel(status: PaymentStatus): string {
    const option = this.paymentStatusOptions.find(opt => opt.value === status);
    return option ? option.label : status;
  }

  getReconciliationStatusLabel(status: ReconciliationStatus): string {
    const option = this.reconciliationStatusOptions.find(opt => opt.value === status);
    return option ? option.label : status;
  }

  getPaymentStatusClass(status: PaymentStatus): string {
    switch (status) {
      case PaymentStatus.VOLLSTAENDIG:
        return 'status-success';
      case PaymentStatus.TEILWEISE:
        return 'status-warning';
      case PaymentStatus.ÜBERZAHLT:
      case PaymentStatus.UNTERZAHLT:
      case PaymentStatus.DOPPELT:
        return 'status-danger';
      case PaymentStatus.STORNIERT:
      case PaymentStatus.ZURÜCKGEBUCHT:
        return 'status-secondary';
      default:
        return 'status-info';
    }
  }
}
